import React from "react";
import "./WinnerPopup.scss";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { SelectWinLoseRecord } from "../../redux/2d-slice/gameInfo2dSlice";
import { Select1dWinLoseRecord } from "../../redux/1d-slice/gameInfo1dSlice";
import { SelectWinLoseRecord3d } from "../../redux/3d_game_Slice/gameinfo3d";
import { SelectTitliWinLoseRecord } from "../../redux/titli-slice/gameInfoTitliSlice";

const WinnerPopup = () => {
  const navigate = useNavigate();

  const winLoseRecord1D = useSelector(Select1dWinLoseRecord);
  const winLoseRecord2D = useSelector(SelectWinLoseRecord);
  const winLoseRecord3D = useSelector(SelectWinLoseRecord3d);
  const winLoseRecordTitli = useSelector(SelectTitliWinLoseRecord);

   let winLoseRecord = {};

  if (winLoseRecordTitli?.en === "LUCKY_SORAT_CLAIM_TICKET") {
    // console.log(winLoseRecordTitli?.en)
    winLoseRecord = winLoseRecordTitli;
  }
  else if (winLoseRecord3D?.en === "PICK_THREE_TICKET_CLAIM") {
    // console.log(winLoseRecord3D?.en)
    winLoseRecord = winLoseRecord3D;
  }
  else if (winLoseRecord2D?.en === "MINI_LOTTERY_TICKET_CLAIM") {
    // console.log(winLoseRecord2D?.en)
    winLoseRecord = winLoseRecord2D;
  }
  else if (winLoseRecord1D?.en === "TWO_CHANCE_TICKET_CLAIM") {
    // console.log(winLoseRecord1D?.en)
    winLoseRecord = winLoseRecord1D;
  }


  // console.log(winLoseRecord)

  const {
    msg = "",
    err = false,
    data = {},
  } = winLoseRecord;

  const ticket_id = data?.ticket_id ?? "N/A";
  const total_bet_amount = data?.total_bet_amount ?? 0;
  const total_win_amount = data?.total_win_amount ?? 0;
  const result_card = data?.card_details || {};
  const result_name = data?.result_card || "";
  const last_win_cards = data?.last_win_cards || [];

  // Determine UI mode from msg
  const isNoWin = msg === "No Winning Ticket!";
  const isAlreadyClaimed = msg === "Ticket Is Already Claimed!";
  const isNotDeclared = msg === "Result Not Declared!";
  const isSuccess = msg === "Data delivered successfully.!!";

  const isWin = total_win_amount > 0;

  // Winning numbers list
  const winCards = isSuccess || isAlreadyClaimed || isWin ? last_win_cards : [];

  // Animation images
  const getImage = () => {
    if (isNotDeclared) return "/images/wait.gif";
    if (isSuccess && isWin) return "/images/Trophy.gif";
    if (isAlreadyClaimed) return "/images/Trophy.gif";
    return "/images/fall.gif"; // default
  };

  return (
    <div className="winner-popup-overlay">
      <div className="winner-popup">
        <button className="close-btn" onClick={() => navigate(-1)}>✖</button>
    
        {/* Animation */}
        <div className="animated-img">
          <img
            src={getImage()}
            alt="status"
            onError={(e) => (e.target.src = "/images/default.gif")}
          />
        </div>

        {/* Title from msg */}
        <h2 className="title">
          {isSuccess
            ? "🎉 Congratulations! 🎉"
            : isNoWin
              ? "😢 Better Luck Next Time!"
              : msg}
        </h2>


        {/* Ticket Info */}
        <p className="ticket">
          <strong>Ticket ID:</strong> {ticket_id}
        </p>

        {(isSuccess) && (
          <p className="amount">
            <strong>Total Bet:</strong> ₹{total_bet_amount}
          </p>
        )}

        {/* Show Winning Amount only when required */}
        {(isSuccess) && (
          <div className="cards-section">
            <h3>
              <strong>Winning Amount</strong>
            </h3>
            <div className="cards-list">₹{total_win_amount}</div>
          </div>
        )}

        {/* Show Winning Numbers only when required */}
        {/* {(isSuccess) && winCards.length > 0 && (
          <div className="cards-section">
            <h3>
              <strong>Winning Numbers</strong>
            </h3>
            <div className="cards-list">
              {winCards.map((c, i) => (
                <div key={i} className="card-row">
                  {c}
                </div>
              ))}
            </div>
          </div>
        )} */}

        {/* Backend message */}
        <p className="msg" style={{ color: "green" }}>{msg}</p>

        {/* Button */}
        <button className="claim-btn" onClick={() => navigate(-1)}>
          OK
        </button>
      </div>
    </div>
  );
};

export default WinnerPopup;
